import React from "react";
import { SlTag } from "react-icons/sl";
import * as Styles from "../../styles";
import { CustomTooltip } from "../../customTooltip";

interface Props {
  observacoes: string;
  onClick?: () => void;
}

export const ObsCell: React.FC<Props> = ({ observacoes, onClick }) => (
  <CustomTooltip
    followCursor
    title={
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "4px 0px",
          gap: 8,
        }}
      >
        <div>
          <SlTag size={14} />
        </div>
        <p>{observacoes || "--"}</p>
      </div>
    }
    placement="top-start"
  >
    <Styles.Td
      className="obsTd"
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : undefined }}
    >
      <SlTag />
    </Styles.Td>
  </CustomTooltip>
);
